
import Form from "./Form.vue";
import { useStore } from 'vuex';
import { defineComponent, ref,onMounted,computed, toRefs, reactive} from 'vue'


export default defineComponent({
  components: {
    Form
  },
  setup(){
     const form = reactive({
      id: "",
      product_type_name: "",
      conv_to_l15_divisor: "",
    });
    const form_action = ref('save')
    const visible = ref(false);
    const store = useStore();

   const fields = ref([
      {
        title: "Product Type Name",
        dataIndex: "product_type_name",
      },
      {
        title: "Conversion To L15 Divisor",
        dataIndex: "conv_to_l15_divisor",
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: "Action",
        dataIndex: "action",
        slots: { customRender: "action" },
        align: 'center'
      },
    ]);

    const index = (payload={page: 1}) => {
      store.dispatch("ProductType/index", payload);
    };
    
    const editRecord = (record: any) => {
      form_action.value = 'update'
      const { id, product_type_name, conv_to_l15_divisor} = toRefs(form);
      id.value = record.id;
      product_type_name.value = record.product_type_name;
      conv_to_l15_divisor.value = record.conv_to_l15_divisor;
      visible.value = true;
    };

    const createRecord = () => {
      form_action.value = 'save'
      const { product_type_name, conv_to_l15_divisor  } = toRefs(form);
      product_type_name.value = '';
      conv_to_l15_divisor.value = '';
      visible.value = true;
    };

    const deleteRecord = (record: any) => {
      store.dispatch("ProductType/destroy", record.id);
    };

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record);
    }

    const storeRecord = (payload = {}) => {
      store
        .dispatch("ProductType/store", payload)
        .then(() => (visible.value = false));
    };

    const updateRecord = (payload = {}) => {
      store
        .dispatch("ProductType/update", payload)
        .then(() => (visible.value = false));
    };

    const filterRecord = (payload: any) => {
      index(payload);
    }

    const items = computed(() => store.getters["ProductType/items"]);
    const loading = computed(() => store.getters["ProductType/status"]);

    onMounted(index);


    return {
      loading,
      items,
      fields,
      visible,
      form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    };
  },
});
